import { omit } from "ramda"
import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

@connect((state) => {
  return {
    profile: state.profile,
  }
})
export default class ProfileWatchingWrapper extends React.Component {
  render() {
    const {
      profile,
      validator,
      WrappedComponentClass,
      accessDeniedComponent,
    } = this.props
    if (validator(profile)) {
      const newProps = omit(
        [
          "profile",
          "validator",
          "WrappedComponentClass",
          "accessDeniedComponent",
        ],
        this.props,
      )
      return <WrappedComponentClass {...newProps} />
    }
    return accessDeniedComponent
  }
}

ProfileWatchingWrapper.propTypes = {
  profile: PropTypes.object,
  validator: PropTypes.func.isRequired,
  WrappedComponentClass: PropTypes.func.isRequired,
  accessDeniedComponent: PropTypes.object.isRequired,
}
